import { Box, Checkbox, FormControl, InputAdornment, InputLabel, ListItemText, ListSubheader, MenuItem, Select, TextField } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import { MinimalRoundedButton } from 'newComponents/FilterDefault/FilterClearButton/styles';
import React, { useEffect } from 'react';
import { buttonStyles, buttonStylesDisabled, menuProps } from './styles';
import { useMuiMultSelect } from './hooks';

/**
 * 
 * Componente de multi seleção checkbox com agrupamentos de itens.
 * @param {Object} props - objeto com todas as propriedades que o componente pode receber
 * @param {Oject} props.options - um objeto que pode variar mas que precisa de 2 atributos obrigatórios para a montagem, id e name
 * @param {number} props.options.id - chave que vai identificar cada item do componente
 * @param {string} props.options.name - chave que vai renderizar as labels e identificações visuais das seleções.  
 * @param {Object} props.selected - array de id's previamente selecionados (opcional)
 * @param {Function} props.callback - função que para receber o valor atualizado de itens selecionados no componente
 * @param {string} props.label - Identificação visual para título do componente
 * @param {boolean} props.disabled - desabilita completamente o funcionamento e interações com o componente
 * @param {string} props.width - atributo de estilização para mudar a largura da caixa que controla o componente 
 */

const MuiMultSelect = ( { options, selected, callback, label, disabled, width, showLabel = true } ) => {
	const {
		states,
		handlers,
	} = useMuiMultSelect( { callback, options } );
	const { handleChange, handleRemoveAll, handleSelectAll } = handlers;

	useEffect( () => {
		states.setSelectedOptions( selected ?? [] );
		states.setOptionsLength( options?.length );
	}, [ selected, options ] ); //eslint-disable-line

	return (
		<Box style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: width ? width : '100%' }}>
			{showLabel && <InputLabel>{label}</InputLabel>}
			<FormControl 
				variant='outlined'
				fullWidth
				size='small'
			>
				<Select
					multiple
					value={states?.selectedOptions}
					onChange={( e ) => handleChange( e )}
					displayEmpty={!states.selectedOptions?.length && `0 de ${states?.optionsLength} ${label}`}
					renderValue={( value ) => `${value?.length} de ${states?.optionsLength} ${label}`}
					MenuProps={{
						...menuProps,
						getContentAnchorEl : null,
						anchorOrigin       : {
							vertical   : 'bottom',
							horizontal : 'left',
						},
						transformOrigin: {
							vertical   : 'top',
							horizontal : 'left',
						},
						PaperProps: {
							style: {
								maxHeight : 400,
								overflowY : 'auto',
							},
						},
					}}
					// style={{ color: '#636362' }}
					disabled={disabled}
					endAdornment={
						disabled ?
							<Close 
								style={buttonStylesDisabled} 
							/>
							:
							<Close 
								style={buttonStyles} 
								onClick={handleRemoveAll} 
								onMouseOver={( e ) => e.currentTarget.style.color = 'red'}
								onMouseOut={( e ) => e.currentTarget.style.color = '#636362'}
							/>
					}
				>
					<ListSubheader className='py-2 bg-white'>
						<Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
							<span>{label}</span>
							<MinimalRoundedButton onClick={handleSelectAll}>Selecionar tudo</MinimalRoundedButton>
						</Box>
						<TextField
							size="small"
							autoFocus
							placeholder="Buscar..."
							fullWidth
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search />
									</InputAdornment>
								)
							}}
							onChange={( e ) => states.setSearchText( e.target.value )}
							onKeyDown={( e ) => {
								if ( e.key !== 'Escape' ) {
									e.stopPropagation();
								}
							}}
						/>
					</ListSubheader>
					{states?.displayedOptions?.map( option => (
						<MenuItem key={option?.id} value={option?.id}>
							<Checkbox color='primary' checked={states.selectedOptions?.indexOf( option?.id ) > -1} />
							<ListItemText primary={option?.name}/>
						</MenuItem>
					) )}
				</Select>
			</FormControl>
		</Box>
	);
};

export default MuiMultSelect;